import { CrmTaskStatus } from '@plato/data/prisma';
import { keepPreviousData } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ActivityFeedModelType } from '../../../server/types/customer-activity-feed-types.ts';
import type { RouterInput } from '../../../server/types/infer-trpc-types.ts';
import { api } from '../../../utils/api.ts';
import { useActivityFilters } from './use-activity-filters.ts';

export function useActivityOpenTasks(customerId?: string) {
    const { appliedFilters } = useActivityFilters();

    const modelType = appliedFilters.modelType;
    const taskStatuses = appliedFilters.taskStatuses ?? [];
    const searchText = appliedFilters.searchText ?? '';
    const hasOtherFilters = [
        appliedFilters.orderStatuses,
        appliedFilters.quoteStatuses,
        appliedFilters.noteTypes,
    ].some((value) => !!value?.length);

    const isEnabled =
        !!customerId &&
        (!modelType || modelType === ActivityFeedModelType.TASK) &&
        (!!modelType || !hasOtherFilters || taskStatuses.length > 0) &&
        (taskStatuses.length === 0 || taskStatuses.includes(CrmTaskStatus.OPEN));

    const filters = useMemo(() => {
        return {
            customerId: customerId ?? '',
            searchText,
        } satisfies RouterInput['platoUser']['query']['tasks']['getManyTasks']['getUpcomingCustomerTasks'];
    }, [customerId, searchText]);

    const queryResult = api.platoUser.query.tasks.getManyTasks.getUpcomingCustomerTasks.useQuery(filters, {
        enabled: isEnabled,
        placeholderData: keepPreviousData,
    });

    return {
        ...queryResult,
        isLoading: isEnabled && queryResult.isLoading,
        isEnabled,
        taskData: isEnabled ? queryResult.data || [] : [],
    };
}
